import * as React from 'react'
import * as Collapsible from '@radix-ui/react-collapsible'
import styled from 'styled-components'

import Icon from '~/truck/icon'
import Label from '~/truck/label'

interface FilterItemLayoutProps {
  title: string
  children: React.ReactNode
  defaultIsOpen?: boolean
}

const HeaderContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: ${props => props.theme.spacing.cozy}px ${props => props.theme.spacing.cozy * 1.5}px;

  & > span {
    font-size: ${props => props.theme.spacing.cozy * 1.75}px;
  }
`

const StyledCollapsibleRoot = styled(Collapsible.Root)`
  flex-shrink: 0;
`

export function FilterItemLayout(props: FilterItemLayoutProps) {
  const { title, children } = props

  const [isOpen, setIsOpen] = React.useState<boolean>(() => {
    return props.defaultIsOpen ?? false
  })

  return (
    <StyledCollapsibleRoot open={isOpen} onOpenChange={open => setIsOpen(open)}>
      <Collapsible.Trigger asChild>
        <HeaderContainer>
          <Label as="span" $textStyle="h6Semibold" $color="grayscale80">
            {title}
          </Label>
          <Icon type={isOpen ? 'caret-up' : 'caret-down'} size="sm" color="grayscale80" />
        </HeaderContainer>
      </Collapsible.Trigger>
      <Collapsible.Content>{children}</Collapsible.Content>
    </StyledCollapsibleRoot>
  )
}
